function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import isRetryAllowed from 'is-retry-allowed';
export var namespace = 'axios-retry';
export function isNetworkError(error) {
    var CODE_EXCLUDE_LIST = [
        'ERR_CANCELED',
        'ECONNABORTED'
    ];
    if (error.response) {
        return false;
    }
    if (!error.code) {
        return false;
    }
    // Prevents retrying timed out & cancelled requests
    if (CODE_EXCLUDE_LIST.includes(error.code)) {
        return false;
    }
    // Prevents retrying unsafe errors
    return isRetryAllowed(error);
}
var SAFE_HTTP_METHODS = [
    'get',
    'head',
    'options'
];
var IDEMPOTENT_HTTP_METHODS = SAFE_HTTP_METHODS.concat([
    'put',
    'delete'
]);
export function isRetryableError(error) {
    return error.code !== 'ECONNABORTED' && (!error.response || error.response.status === 429 || error.response.status >= 500 && error.response.status <= 599);
}
export function isSafeRequestError(error) {
    var _error_config;
    if (!((_error_config = error.config) === null || _error_config === void 0 ? void 0 : _error_config.method)) {
        // Cannot determine if the request can be retried
        return false;
    }
    return isRetryableError(error) && SAFE_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
export function isIdempotentRequestError(error) {
    var _error_config;
    if (!((_error_config = error.config) === null || _error_config === void 0 ? void 0 : _error_config.method)) {
        // Cannot determine if the request can be retried
        return false;
    }
    return isRetryableError(error) && IDEMPOTENT_HTTP_METHODS.indexOf(error.config.method) !== -1;
}
export function isNetworkOrIdempotentRequestError(error) {
    return isNetworkError(error) || isIdempotentRequestError(error);
}
export function retryAfter() {
    var error = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : undefined;
    var _error_response;
    var retryAfterHeader = error === null || error === void 0 ? void 0 : (_error_response = error.response) === null || _error_response === void 0 ? void 0 : _error_response.headers['retry-after'];
    if (!retryAfterHeader) {
        return 0;
    }
    // if the retry after header is a number, convert it to milliseconds
    var retryAfterMs = (Number(retryAfterHeader) || 0) * 1000;
    // If the retry after header is a date, get the number of milliseconds until that date
    if (retryAfterMs === 0) {
        retryAfterMs = (new Date(retryAfterHeader).valueOf() || 0) - Date.now();
    }
    return Math.max(0, retryAfterMs);
}
function noDelay() {
    var _retryNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
    return Math.max(0, retryAfter(error));
}
export function exponentialDelay() {
    var retryNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined, delayFactor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 100;
    var calculatedDelay = Math.pow(2, retryNumber) * delayFactor;
    var delay = Math.max(calculatedDelay, retryAfter(error));
    var randomSum = delay * 0.2 * Math.random(); // 0-20% of the delay
    return delay + randomSum;
}
/**
 * Linear delay
 * @param {number | undefined} delayFactor - delay factor in milliseconds (default: 100)
 * @returns {function} (retryNumber: number, error: AxiosError | undefined) => number
 */ export function linearDelay() {
    var delayFactor = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 100;
    return function() {
        var retryNumber = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, error = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        var delay = retryNumber * delayFactor;
        return Math.max(delay, retryAfter(error));
    };
}
export var DEFAULT_OPTIONS = {
    retries: 3,
    retryCondition: isNetworkOrIdempotentRequestError,
    retryDelay: noDelay,
    shouldResetTimeout: false,
    onRetry: function() {},
    onMaxRetryTimesExceeded: function() {},
    validateResponse: null
};
function getRequestOptions(config, defaultOptions) {
    return _object_spread({}, DEFAULT_OPTIONS, defaultOptions, config[namespace]);
}
function setCurrentState(config, defaultOptions) {
    var resetLastRequestTime = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var currentState = getRequestOptions(config, defaultOptions || {});
    currentState.retryCount = currentState.retryCount || 0;
    if (!currentState.lastRequestTime || resetLastRequestTime) {
        currentState.lastRequestTime = Date.now();
    }
    config[namespace] = currentState;
    return currentState;
}
function fixConfig(axiosInstance, config) {
    // @ts-ignore
    if (axiosInstance.defaults.agent === config.agent) {
        // @ts-ignore
        delete config.agent;
    }
    if (axiosInstance.defaults.httpAgent === config.httpAgent) {
        delete config.httpAgent;
    }
    if (axiosInstance.defaults.httpsAgent === config.httpsAgent) {
        delete config.httpsAgent;
    }
}
function shouldRetry(currentState, error) {
    return _shouldRetry.apply(this, arguments);
}
function _shouldRetry() {
    _shouldRetry = _async_to_generator(function(currentState, error) {
        var retries, retryCondition, shouldRetryOrPromise, shouldRetryPromiseResult, _err;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    retries = currentState.retries, retryCondition = currentState.retryCondition;
                    shouldRetryOrPromise = (currentState.retryCount || 0) < retries && retryCondition(error);
                    if (!((typeof shouldRetryOrPromise === "undefined" ? "undefined" : _type_of(shouldRetryOrPromise)) === 'object')) return [
                        3,
                        4
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        shouldRetryOrPromise
                    ];
                case 2:
                    shouldRetryPromiseResult = _state.sent();
                    // keep return true unless shouldRetryPromiseResult return false for compatibility
                    return [
                        2,
                        shouldRetryPromiseResult !== false
                    ];
                case 3:
                    _err = _state.sent();
                    return [
                        2,
                        false
                    ];
                case 4:
                    return [
                        2,
                        shouldRetryOrPromise
                    ];
            }
        });
    });
    return _shouldRetry.apply(this, arguments);
}
function handleRetry(axiosInstance, currentState, error, config) {
    return _handleRetry.apply(this, arguments);
}
function _handleRetry() {
    _handleRetry = _async_to_generator(function(axiosInstance, currentState, error, config) {
        var _config_signal, retryDelay, shouldResetTimeout, onRetry, delay, lastRequestDuration, timeout;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    currentState.retryCount += 1;
                    retryDelay = currentState.retryDelay, shouldResetTimeout = currentState.shouldResetTimeout, onRetry = currentState.onRetry;
                    delay = retryDelay(currentState.retryCount, error);
                    // Axios fails merging this configuration to the default configuration because it has an issue
                    // with circular structures: https://github.com/mzabriskie/axios/issues/370
                    fixConfig(axiosInstance, config);
                    if (!shouldResetTimeout && config.timeout && currentState.lastRequestTime) {
                        lastRequestDuration = Date.now() - currentState.lastRequestTime;
                        timeout = config.timeout - lastRequestDuration - delay;
                        if (timeout <= 0) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        config.timeout = timeout;
                    }
                    config.transformRequest = [
                        function(data) {
                            return data;
                        }
                    ];
                    return [
                        4,
                        onRetry(currentState.retryCount, error, config)
                    ];
                case 1:
                    _state.sent();
                    if ((_config_signal = config.signal) === null || _config_signal === void 0 ? void 0 : _config_signal.aborted) {
                        return [
                            2,
                            Promise.resolve(axiosInstance(config))
                        ];
                    }
                    return [
                        2,
                        new Promise(function(resolve) {
                            var _config_signal;
                            var abortListener = function() {
                                clearTimeout(timeout);
                                resolve(axiosInstance(config));
                            };
                            var timeout = setTimeout(function() {
                                var _config_signal;
                                resolve(axiosInstance(config));
                                if ((_config_signal = config.signal) === null || _config_signal === void 0 ? void 0 : _config_signal.removeEventListener) {
                                    config.signal.removeEventListener('abort', abortListener);
                                }
                            }, delay);
                            if ((_config_signal = config.signal) === null || _config_signal === void 0 ? void 0 : _config_signal.addEventListener) {
                                config.signal.addEventListener('abort', abortListener, {
                                    once: true
                                });
                            }
                        })
                    ];
            }
        });
    });
    return _handleRetry.apply(this, arguments);
}
function handleMaxRetryTimesExceeded(currentState, error) {
    return _handleMaxRetryTimesExceeded.apply(this, arguments);
}
function _handleMaxRetryTimesExceeded() {
    _handleMaxRetryTimesExceeded = _async_to_generator(function(currentState, error) {
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(currentState.retryCount >= currentState.retries)) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        currentState.onMaxRetryTimesExceeded(error, currentState.retryCount)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2
                    ];
            }
        });
    });
    return _handleMaxRetryTimesExceeded.apply(this, arguments);
}
var axiosRetry = function(axiosInstance, defaultOptions) {
    var requestInterceptorId = axiosInstance.interceptors.request.use(function(config) {
        var _config_namespace;
        setCurrentState(config, defaultOptions, true);
        if ((_config_namespace = config[namespace]) === null || _config_namespace === void 0 ? void 0 : _config_namespace.validateResponse) {
            // by setting this, all HTTP responses will be go through the error interceptor first
            config.validateStatus = function() {
                return false;
            };
        }
        return config;
    });
    var responseInterceptorId = axiosInstance.interceptors.response.use(null, /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(error) {
            var _currentState_validateResponse, config, currentState;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        config = error.config;
                        // If we have no information to retry the request
                        if (!config) {
                            return [
                                2,
                                Promise.reject(error)
                            ];
                        }
                        currentState = setCurrentState(config, defaultOptions);
                        if (error.response && ((_currentState_validateResponse = currentState.validateResponse) === null || _currentState_validateResponse === void 0 ? void 0 : _currentState_validateResponse.call(currentState, error.response))) {
                            // no issue with response
                            return [
                                2,
                                error.response
                            ];
                        }
                        return [
                            4,
                            shouldRetry(currentState, error)
                        ];
                    case 1:
                        if (_state.sent()) {
                            return [
                                2,
                                handleRetry(axiosInstance, currentState, error, config)
                            ];
                        }
                        return [
                            4,
                            handleMaxRetryTimesExceeded(currentState, error)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            Promise.reject(error)
                        ];
                }
            });
        });
        return function(error) {
            return _ref.apply(this, arguments);
        };
    }());
    return {
        requestInterceptorId: requestInterceptorId,
        responseInterceptorId: responseInterceptorId
    };
};
// Compatibility with CommonJS
axiosRetry.isNetworkError = isNetworkError;
axiosRetry.isSafeRequestError = isSafeRequestError;
axiosRetry.isIdempotentRequestError = isIdempotentRequestError;
axiosRetry.isNetworkOrIdempotentRequestError = isNetworkOrIdempotentRequestError;
axiosRetry.exponentialDelay = exponentialDelay;
axiosRetry.linearDelay = linearDelay;
axiosRetry.isRetryableError = isRetryableError;
export default axiosRetry;
